{
  "title": "Assistant IA",
  "newChat": "Nouvelle discussion",
  "untitled": "Sans titre",
  "emptyHint": "Posez des questions sur les appareils, champs, plans d'irrigation ou l'activité récente de votre ferme.",
  "placeholder": "Posez une question…",
  "send": "Envoyer",
  "spend": "Dépensé ${{spent}} sur ${{budget}} ce mois-ci — ${{remaining}} restants.",
  "budgetExceeded": "Cette ferme a atteint son budget mensuel d'assistant IA.",
  "unavailable": "L'assistant IA n'est pas disponible pour le moment.",
  "experimental": "Expérimental"
}
